import { render } from "./SuperviseurDashboard.vue?vue&type=template&id=29482938&scoped=true&ts=true"
import script from "./SuperviseurDashboard.vue?vue&type=script&lang=ts"
export * from "./SuperviseurDashboard.vue?vue&type=script&lang=ts"

import "./SuperviseurDashboard.vue?vue&type=style&index=0&id=29482938&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29482938"]])

export default __exports__